import React from 'react';
import CascadingMenuButton from '@jbrowse/core/ui/CascadingMenuButton';
import { observer } from 'mobx-react';
// icons
import MenuIcon from '@mui/icons-material/Menu';
const ViewMenu = observer(function ({ model, IconButtonProps, IconProps, }) {
    const items = model.menuItems();
    return items.length ? (React.createElement(CascadingMenuButton, { menuItems: items, "data-testid": "view_menu_icon" },
        React.createElement(MenuIcon, { ...IconProps }))) : null;
});
export default ViewMenu;
